import { Reducer } from 'redux';
import { IAction } from '../types';
import { GetListProps } from '@/views/user/wallet/service';
import LocalStore from '@/utils/store';

export interface BaseTrumpetInfoJson {
  uid: any;
  selectUid: any;
  selectAccount: string;
}

export interface TrumpetInfoState {
  data: GetListProps[];
  uid: any;
  selectUid: any;
  selectAccount: string;
  historyList: BaseTrumpetInfoJson[];
}

const localBaseInfo = LocalStore.getValue<TrumpetInfoState>('BASE_TRUMPET_INFO') || {};

export const trumpetInfo: TrumpetInfoState = {
  data: [],
  uid: '',
  selectUid: '',
  selectAccount: '',
  historyList: [],
  ...localBaseInfo
};

export const setTrumpetInfo: (payload: TrumpetInfoState) => IAction<TrumpetInfoState> = (
  payload: TrumpetInfoState
) => ({
  type: 'setTrumpetInfo',
  payload
});

const trumpetInfoReducer: Reducer<TrumpetInfoState, IAction<any>> = (state = trumpetInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setTrumpetInfo':
      LocalStore.setValue('BASE_TRUMPET_INFO', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default trumpetInfoReducer;
